export default __webpack_public_path__ + "static/media/köide_003_small.fe8760e1.png";